import { JSX } from 'solid-js';
import { NavbarAction } from './NavbarAction';

interface NavbarActionsProps {
  helpUrl?: string;
}

export const NavbarActions = (props: NavbarActionsProps): JSX.Element => {
  const openHelp = (): void => {
    if (props.helpUrl) {
      window.open(props.helpUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div class="flex items-center gap-5" data-testid="navbar-actions">
      <NavbarAction
        icon="tc-icon-help"
        disabled={!props.helpUrl}
        onClick={openHelp}
      />
    </div>
  );
};
